import React, { useEffect, useState } from "react";
import { decodeToken } from "../../utils/commonFunctions";
import axios from "axios";

import "./homestyle.css";
import Edit from "../../assets/images/edit.png";
import Dashboard from "../../assets/images/dashboard.png";
import TickArrow from "../../assets/images/tickarrow.png";
import Arrowright from "../../assets/images/SendLetter.png";
import LoginHeader from "../../layouts/loginHeader";
import Header from "../../layouts/Header";
import Chatbot from "../chats/Chatbot";
import SideBar from "../chats/Sidebar";
import HomeHeader from "../../components/HomeHeader";
import SideBar1 from "../chats/sidebar1";
import HomeHeader1 from "../../components/HomeHeader1";
import ContentInner2 from "./ContentInner2";
import { useChatContext } from "../../context/ChatContext";

const Homescsbc: React.FC = () => {
  
  const { titleId,initialStart } = useChatContext();

  // Toggle Sidebar Function
  // const toggleSidebar = (forceOpen?: boolean) => {
  //   let sidebar = document.getElementById("sidebar");
  //   let content = document.getElementById("content");
  //   let header = document.getElementById("header");

  //   if (forceOpen) {
  //     sidebar?.classList.add("open");  // ✅ Force Open Sidebar
  //     content?.classList.add("shrink");
  //     header?.classList.add("shrink");
  //   } else {
  //     sidebar?.classList.toggle("open");
  //     content?.classList.toggle("shrink");
  //     header?.classList.toggle("shrink");
  //   }
  // };


  return (
    <>
     <div className="sidebar-content-other">
      <SideBar1/>

        <div className="home-page-content-inner">
        <HomeHeader1/>

        <ContentInner2/>
        </div>
      </div>
  
    </>
  );
};

export default Homescsbc;
